var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobileFooter"},[_c('ul',_vm._l((_vm.list),function(item,index){return _c('li',{key:index,class:{ active: _vm.checkUrl === item.url },on:{"click":function($event){return _vm.open(item)}}},[_c('img',{attrs:{"src":_vm.checkUrl === item.url ? item.checkImg : item.img}}),_c('span',[_vm._v(_vm._s(item.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }